module.exports = __webpack_public_path__ + "img/threedot.4d18f308.svg";